import {IApiBusinessProto} from "../provider_api";

export const getSubscriptionType = (business:IApiBusinessProto | null | undefined) => {
  return business?.subscription?.type;
}

// These need to stay in sync with stripe.
export const listingPrice = (practitioners: number | null | undefined) => {

  if (!practitioners || practitioners < 1) {
    return 0;
  }

  return 2400 + 1200 * (practitioners - 1);
}

export const listingPlusBookingPrice = (practitioners: number | null | undefined) => {
  
  if (!practitioners || practitioners < 1) {
    return 0;
  }
  
  return 5400 + 2400 * (practitioners - 1);
}